import React from "react";
import { NavLink } from "react-router-dom";

export default function DashboardNavItem({ children, name, to, styles,action }) {
  return (
    <NavLink to={to} onClick={action}>
      <li
        className={`mb-5 hover:bg-[#01FF00] rounded p-3 cursor-pointer text-nowrap  ${styles} flex justify-center items-center gap-7`}
      >
        {children}
        <p className="text-start w-full">{name}</p>
      </li>
    </NavLink>
  );
}
